var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShapeRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 14,
    viewBox: "0 0 9 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.198 3.14722L5.16613 7.06458L1.19843 10.927L1.198 10.9274C0.94373 11.1764 0.8 11.5144 0.8 11.8678C0.8 12.2213 0.943731 12.5593 1.198 12.8083L1.33793 12.6654L1.19784 12.8081C1.32471 12.9326 1.47535 13.0312 1.64095 13.0983C1.80654 13.1655 1.98396 13.2 2.16304 13.2C2.34211 13.2 2.51954 13.1655 2.68512 13.0983C2.8506 13.0312 3.00115 12.9328 3.12795 12.8084C3.12805 12.8083 3.12814 12.8082 3.12823 12.8081L8.05443 8.01267C8.05454 8.01256 8.05464 8.01245 8.05475 8.01235C8.18251 7.88892 8.28422 7.7418 8.35375 7.57933C8.42335 7.41671 8.45926 7.24209 8.45926 7.06558C8.45926 6.88908 8.42335 6.71445 8.35375 6.55183C8.28429 6.38954 8.18273 6.24257 8.05516 6.11921C8.05492 6.11898 8.05467 6.11874 8.05443 6.1185L3.12848 1.26674L3.12823 1.26649C3.00136 1.14198 2.85072 1.04343 2.68512 0.976268C2.51954 0.909113 2.34211 0.874601 2.16304 0.874601C1.98396 0.874601 1.80653 0.909113 1.64095 0.976268C1.47535 1.04343 1.32471 1.14198 1.19784 1.26649C0.94367 1.51548 0.8 1.85339 0.8 2.20678C0.8 2.56007 0.943595 2.8979 1.19764 3.14686C1.19776 3.14698 1.19788 3.1471 1.198 3.14722Z",
    fill: "#32193A",
    stroke: "#32193A",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeRight);
export default __webpack_public_path__ + "static/media/ShapeRight.9606dc9c11bd1f7422220afcd0295af2.svg";
export { ForwardRef as ReactComponent };